export const AUDIT_EVENTS = {
  // Order Events
  ORDER_CREATED: 'ORDER_CREATED',
  ORDER_SENT: 'ORDER_SENT',
  ORDER_MANUAL_SENT: 'ORDER_MANUAL_SENT', // Set to status SENT from ListView
  ORDER_MANUAL_DRAFT: 'ORDER_MANUAL_DRAFT', // Set to status DRAFT from ListView
  ORDER_RECEIVED: 'ORDER_RECEIVED', // From SENT to RECEIVED
  ORDER_RECEPTION_VALIDATED: 'ORDER_RECEPTION_VALIDATED', // From SENT or RECEIVED to COMPLIANT or NON_COMPLIANT
  ORDER_RECEIVED_USING_SCAN_DELIVERY_NOTE: 'ORDER_RECEIVED_USING_SCAN_DELIVERY_NOTE', // Reception via scan BDL mobile
  ORDER_RECEIVED_VIA_MOBILE: 'ORDER_RECEIVED_VIA_MOBILE',
  ORDER_UPDATED_VIA_MOBILE: 'ORDER_UPDATED_VIA_MOBILE',
  ORDER_RECEPTION_VALIDATED_VIA_MOBILE: 'ORDER_RECEPTION_VALIDATED_VIA_MOBILE',
  ORDER_RECEPTION_CANCELED: 'ORDER_RECEPTION_CANCELED', // From COMPLIANT or NON_COMPLIANT to SENT or RECEIVED
  ORDER_CREDIT_REQUEST_PROCESSED: 'ORDER_CREDIT_REQUEST_PROCESSED', // Set to status CREDIT_REQUEST_PROCESSED
  ORDER_EDN_RECEIVED: 'ORDER_EDN_RECEIVED',
  ORDER_EDI_ERROR: 'ORDER_EDI_ERROR',
  ORDER_EMAIL_ERROR: 'ORDER_EMAIL_ERROR',
  ORDER_UPDATED: 'ORDER_UPDATED',
  ORDER_PREPARATION_STARTED: 'ORDER_PREPARATION_STARTED', // Set to PREPARING by the central kitchen
  ORDER_PREPARATION_VALIDATED: 'ORDER_PREPARATION_VALIDATED', // Set to a PREPARED status by the central kitchen

  // External Order Events
  EXTERNAL_ORDER_CREATED: 'EXTERNAL_ORDER_CREATED',
  EXTERNAL_ORDER_DRAFT_VALIDATED: 'EXTERNAL_ORDER_DRAFT_VALIDATED',
  EXTERNAL_ORDER_PREPARATION_STARTED: 'EXTERNAL_ORDER_PREPARATION_STARTED',
  EXTERNAL_ORDER_PREPARATION_VALIDATED: 'EXTERNAL_ORDER_PREPARATION_VALIDATED',
  EXTERNAL_ORDER_SET_BACK_TO_DRAFT: 'EXTERNAL_ORDER_SET_BACK_TO_DRAFT',
  EXTERNAL_ORDER_SET_BACK_TO_TO_COME: 'EXTERNAL_ORDER_SET_BACK_TO_TO_COME',
  EXTERNAL_ORDER_SET_BACK_TO_IN_PREPARATION: 'EXTERNAL_ORDER_SET_BACK_TO_IN_PREPARATION',
  EXTERNAL_ORDER_UPDATED: 'EXTERNAL_ORDER_UPDATED',

  // Supplier Product Events
  SUPPLIER_PRODUCT_CREATED: 'SUPPLIER_PRODUCT_CREATED',
  SUPPLIER_PRODUCT_LINKED: 'SUPPLIER_PRODUCT_LINKED',
  SUPPLIER_PRODUCT_UNLINKED: 'SUPPLIER_PRODUCT_UNLINKED',
  INVOICE_PACKAGING_UPDATED: 'INVOICE_PACKAGING_UPDATED',
  RECEPTION_PACKAGING_UPDATED: 'RECEPTION_PACKAGING_UPDATED',
  SUPPLIER_PRODUCT_DISABLED: 'SUPPLIER_PRODUCT_DISABLED',
  SUPPLIER_PRODUCT_ENABLED: 'SUPPLIER_PRODUCT_ENABLED',
  SUPPLIER_PRODUCT_PRICE_UPDATED: 'SUPPLIER_PRODUCT_PRICE_UPDATED',
  SUPPLIER_PRODUCT_UPDATED: 'SUPPLIER_PRODUCT_UPDATED',
  SUPPLIER_PRODUCT_INPUT_PRICE_UPDATED: 'SUPPLIER_PRODUCT_INPUT_PRICE_UPDATED',
  SUPPLIER_PRODUCT_AVAILABILITIES_UPDATED: 'SUPPLIER_PRODUCT_AVAILABILITIES_UPDATED',

  // Inventory Events
  INVENTORY_CREATED: 'INVENTORY_CREATED',
  INVENTORY_DATE_CHANGED: 'INVENTORY_DATE_CHANGED',
  INVENTORY_INVALIDATED: 'INVENTORY_INVALIDATED',
  INVENTORY_UPDATED: 'INVENTORY_UPDATED',
  INVENTORY_VALIDATED: 'INVENTORY_VALIDATED',
  INVENTORY_UPDATED_VIA_MOBILE: 'INVENTORY_UPDATED_VIA_MOBILE',

  // Transfer Events
  TRANSFER_UPDATED: 'TRANSFER_UPDATED',
  DRAFT_TRANSFER_RECIPIENT_CREATED: 'DRAFT_TRANSFER_RECIPIENT_CREATED',
  DRAFT_TRANSFER_SENDER_CREATED: 'DRAFT_TRANSFER_SENDER_CREATED',
  DRAFT_TRANSFER_SENT: 'DRAFT_TRANSFER_SENT',
  DRAFT_TRANSFER_SENT_NO_MAIL: 'DRAFT_TRANSFER_SENT_NO_MAIL',
  DELIVERY_NOTE_TRANSFER_SENT: 'DELIVERY_NOTE_TRANSFER_SENT',
  DELIVERY_NOTE_TRANSFER_SENT_NO_MAIL: 'DELIVERY_NOTE_TRANSFER_SENT_NO_MAIL',
  RECEPTION_TRANSFER_SAVED: 'RECEPTION_TRANSFER_SAVED',
  RECEPTION_TRANSFER_VALIDATED: 'RECEPTION_TRANSFER_VALIDATED',
  TRANSFER_SET_TO_DRAFT: 'TRANSFER_SET_TO_DRAFT',
  TRANSFER_SET_TO_INVOICED: 'TRANSFER_SET_TO_INVOICED',
  TRANSFER_CANCEL_INVOICED: 'TRANSFER_CANCEL_INVOICED',
  TRANSFER_CANCEL_SENDING: 'TRANSFER_CANCEL_SENDING',
  TRANSFER_CANCEL_RECEPTION: 'TRANSFER_CANCEL_RECEPTION',

  // Catalog Events
  SUPPLIER_PRODUCT_CATALOG_CREATED: 'SUPPLIER_PRODUCT_CATALOG_CREATED',
  SUPPLIER_PRODUCT_CATALOG_UPDATED: 'SUPPLIER_PRODUCT_CATALOG_UPDATED',
  SUPPLIER_PRODUCT_CATALOG_DEACTIVATED: 'SUPPLIER_PRODUCT_CATALOG_DEACTIVATED',
  SUPPLIER_PRODUCT_PACKAGING_CATALOG_UPDATED: 'SUPPLIER_PRODUCT_PACKAGING_CATALOG_UPDATED',
  SUPPLIER_PRODUCT_PRICE_CATALOG_UPDATED: 'SUPPLIER_PRODUCT_PRICE_CATALOG_UPDATED',

  // Recipe Events
  RECIPE_CREATED: 'RECIPE_CREATED',
  RECIPE_UPDATED: 'RECIPE_UPDATED',
  RECIPE_DISABLED: 'RECIPE_DISABLED',
  RECIPE_ENABLED: 'RECIPE_ENABLED',
  RECIPE_VARIANT_ADDED: 'RECIPE_VARIANT_ADDED',
  RECIPE_VARIANT_REMOVED: 'RECIPE_VARIANT_REMOVED',
  RECIPE_VARIANT_STORES_UPDATED: 'RECIPE_VARIANT_STORES_UPDATED',
  RECIPE_VARIANT_RENAMED: 'RECIPE_VARIANT_RENAMED',
  RECIPE_COMPOSITION_UPDATED: 'RECIPE_COMPOSITION_UPDATED',
  RECIPE_VARIANT_COMPOSITION_UPDATED: 'RECIPE_VARIANT_COMPOSITION_UPDATED',

  // Product Events
  PRODUCT_CREATED: 'PRODUCT_CREATED',
  PRODUCT_UPDATED: 'PRODUCT_UPDATED',
  PRODUCT_DISABLED: 'PRODUCT_DISABLED',
  PRODUCT_ENABLED: 'PRODUCT_ENABLED',
  PRODUCT_COMPOSITION_UPDATED: 'PRODUCT_COMPOSITION_UPDATED',
  PRODUCT_CASHIER_PRODUCTS_UPDATED: 'PRODUCT_CASHIER_PRODUCTS_UPDATED',
};

export const AUDIT_EVENTS_CONFIG = {
  // Order
  [AUDIT_EVENTS.ORDER_CREATED]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_CREATED',
    icon: '/images/inpulse/add-black.svg',
  },
  [AUDIT_EVENTS.ORDER_SENT]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_SENT',
    icon: '/images/inpulse/send-black-small.svg',
  },
  [AUDIT_EVENTS.ORDER_MANUAL_SENT]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_MANUAL_SENT',
    icon: '/images/inpulse/send-black-small.svg',
  },
  [AUDIT_EVENTS.ORDER_MANUAL_DRAFT]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_MANUAL_DRAFT',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.ORDER_RECEIVED]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_RECEIVED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.ORDER_RECEPTION_VALIDATED]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_RECEPTION_VALIDATED',
    icon: '/images/inpulse/done-black-small.svg',
  },
  [AUDIT_EVENTS.ORDER_RECEIVED_USING_SCAN_DELIVERY_NOTE]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_RECEIVED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
    viaScanDeliveryNote: true,
  },
  [AUDIT_EVENTS.ORDER_RECEIVED_VIA_MOBILE]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_RECEIVED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
    viaMobileApp: true,
  },
  [AUDIT_EVENTS.ORDER_UPDATED_VIA_MOBILE]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_UPDATED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
    viaMobileApp: true,
  },
  [AUDIT_EVENTS.ORDER_RECEPTION_VALIDATED_VIA_MOBILE]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_RECEPTION_VALIDATED',
    icon: '/images/inpulse/done-black-small.svg',
    viaMobileApp: true,
  },
  [AUDIT_EVENTS.ORDER_RECEPTION_CANCELED]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_RECEPTION_CANCELED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.ORDER_CREDIT_REQUEST_PROCESSED]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_CREDIT_REQUEST_PROCESSED',
    icon: '/images/inpulse/done-black-small.svg',
  },
  [AUDIT_EVENTS.ORDER_EDN_RECEIVED]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_EDN_RECEIVED',
    icon: '/images/inpulse/receipt-attachment.svg',
  },
  [AUDIT_EVENTS.ORDER_EDI_ERROR]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_EDI_ERROR',
    icon: '/images/inpulse/warning-red-small.svg',
  },
  [AUDIT_EVENTS.ORDER_EMAIL_ERROR]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_EMAIL_ERROR',
    icon: '/images/inpulse/warning-red-small.svg',
  },
  [AUDIT_EVENTS.ORDER_UPDATED]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_UPDATED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.ORDER_PREPARATION_STARTED]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_PREPARATION_STARTED',
    icon: '/images/inpulse/done-black-small.svg',
  },
  [AUDIT_EVENTS.ORDER_PREPARATION_VALIDATED]: {
    label: 'ORDERS.AUDIT_EVENTS.ORDER_PREPARATION_VALIDATED',
    icon: '/images/inpulse/done-black-small.svg',
  },

  // External order
  [AUDIT_EVENTS.EXTERNAL_ORDER_CREATED]: {
    label: 'EXTERNAL_ORDERS.AUDIT_EVENTS.ORDER_CREATED',
    icon: '/images/inpulse/add-black.svg',
  },
  [AUDIT_EVENTS.EXTERNAL_ORDER_DRAFT_VALIDATED]: {
    label: 'EXTERNAL_ORDERS.AUDIT_EVENTS.DRAFT_VALIDATED',
    icon: '/images/inpulse/done-black-small.svg',
  },
  [AUDIT_EVENTS.EXTERNAL_ORDER_PREPARATION_STARTED]: {
    label: 'EXTERNAL_ORDERS.AUDIT_EVENTS.PREPARATION_STARTED',
    icon: '/images/inpulse/done-black-small.svg',
  },
  [AUDIT_EVENTS.EXTERNAL_ORDER_PREPARATION_VALIDATED]: {
    label: 'EXTERNAL_ORDERS.AUDIT_EVENTS.PREPARATION_VALIDATED',
    icon: '/images/inpulse/done-black-small.svg',
  },
  [AUDIT_EVENTS.EXTERNAL_ORDER_SET_BACK_TO_DRAFT]: {
    label: 'EXTERNAL_ORDERS.AUDIT_EVENTS.SET_BACK_TO_DRAFT',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.EXTERNAL_ORDER_SET_BACK_TO_TO_COME]: {
    label: 'EXTERNAL_ORDERS.AUDIT_EVENTS.SET_BACK_TO_TO_COME',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.EXTERNAL_ORDER_SET_BACK_TO_IN_PREPARATION]: {
    label: 'EXTERNAL_ORDERS.AUDIT_EVENTS.SET_BACK_TO_IN_PREPARATION',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.EXTERNAL_ORDER_UPDATED]: {
    label: 'EXTERNAL_ORDERS.AUDIT_EVENTS.ORDER_UPDATED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },

  // Supplier Product
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_CREATED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_CREATED',
    icon: '/images/inpulse/add-black.svg',
  },
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_LINKED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_LINKED',
    icon: '/images/inpulse/inpulse-link-black-small.svg',
  },
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_UNLINKED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_UNLINKED',
    icon: '/images/inpulse/unlink-black-small.svg',
  },
  [AUDIT_EVENTS.RECEPTION_PACKAGING_UPDATED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_RECEPTION_PACKAGING',
    icon: '/images/inpulse/stock-black-small.svg',
  },
  [AUDIT_EVENTS.INVOICE_PACKAGING_UPDATED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_INVOICE_PACKAGING',
    icon: '/images/inpulse/stock-black-small.svg',
  },
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_DISABLED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_DISABLED',
    icon: '/images/inpulse/power-black-small.svg',
  },
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_ENABLED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_ENABLED',
    icon: '/images/inpulse/power-black-small.svg',
  },
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_PRICE_UPDATED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_PRICE',
    icon: '/images/inpulse/payments-black.svg',
  },
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_UPDATED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_UPDATED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_INPUT_PRICE_UPDATED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_INPUT_PRICE',
    icon: '/images/inpulse/payments-black.svg',
  },
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_AVAILABILITIES_UPDATED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_AVAILABILITIES_UPDATED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  // Supplier Product Catalog
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_CATALOG_CREATED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_CATALOG_CREATED',
    icon: '/images/inpulse/add-black.svg',
  },
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_CATALOG_UPDATED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_CATALOG_UPDATED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_CATALOG_DEACTIVATED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_CATALOG_DEACTIVATED',
    icon: '/images/inpulse/close-black-small.svg',
  },
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_PACKAGING_CATALOG_UPDATED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_PACKAGING_CATALOG_UPDATED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.SUPPLIER_PRODUCT_PRICE_CATALOG_UPDATED]: {
    label: 'ADMIN.SUPPLIER_PRODUCTS.AUDIT_EVENTS_PRICE_CATALOG_UPDATED',
    icon: '/images/inpulse/payments-black.svg',
  },

  // Inventory
  [AUDIT_EVENTS.INVENTORY_CREATED]: {
    label: 'STOCKS.AUDIT_EVENTS.INVENTORY_CREATED',
    icon: '/images/inpulse/add-black.svg',
  },
  [AUDIT_EVENTS.INVENTORY_DATE_CHANGED]: {
    label: 'STOCKS.AUDIT_EVENTS.INVENTORY_DATE_CHANGED',
    icon: '/images/inpulse/calendar-black-small.svg',
  },
  [AUDIT_EVENTS.INVENTORY_INVALIDATED]: {
    label: 'STOCKS.AUDIT_EVENTS.INVENTORY_INVALIDATED',
    icon: '/images/inpulse/close-black-small.svg',
  },
  [AUDIT_EVENTS.INVENTORY_UPDATED]: {
    label: 'STOCKS.AUDIT_EVENTS.INVENTORY_UPDATED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.INVENTORY_VALIDATED]: {
    label: 'STOCKS.AUDIT_EVENTS.INVENTORY_VALIDATED',
    icon: '/images/inpulse/done-black-small.svg',
  },
  [AUDIT_EVENTS.INVENTORY_UPDATED_VIA_MOBILE]: {
    label: 'STOCKS.AUDIT_EVENTS.INVENTORY_UPDATED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
    viaMobileApp: true,
  },

  // Transfer
  [AUDIT_EVENTS.DRAFT_TRANSFER_RECIPIENT_CREATED]: {
    label: 'STOCKS.AUDIT_EVENTS.DRAFT_TRANSFER_RECIPIENT_CREATED',
    icon: '/images/inpulse/add-black.svg',
  },
  [AUDIT_EVENTS.DRAFT_TRANSFER_SENDER_CREATED]: {
    label: 'STOCKS.AUDIT_EVENTS.DRAFT_TRANSFER_SENDER_CREATED',
    icon: '/images/inpulse/add-black.svg',
  },
  [AUDIT_EVENTS.DRAFT_TRANSFER_SENT]: {
    label: 'STOCKS.AUDIT_EVENTS.DRAFT_TRANSFER_SENT',
    icon: '/images/inpulse/send-black-small.svg',
  },
  [AUDIT_EVENTS.DRAFT_TRANSFER_SENT_NO_MAIL]: {
    label: 'STOCKS.AUDIT_EVENTS.DRAFT_TRANSFER_SENT_NO_MAIL',
    icon: '/images/inpulse/send-black-small.svg',
  },
  [AUDIT_EVENTS.DELIVERY_NOTE_TRANSFER_SENT]: {
    label: 'STOCKS.AUDIT_EVENTS.DELIVERY_NOTE_TRANSFER_SENT',
    icon: '/images/inpulse/send-black-small.svg',
  },
  [AUDIT_EVENTS.DELIVERY_NOTE_TRANSFER_SENT_NO_MAIL]: {
    label: 'STOCKS.AUDIT_EVENTS.DELIVERY_NOTE_TRANSFER_SENT_NO_MAIL',
    icon: '/images/inpulse/send-black-small.svg',
  },
  [AUDIT_EVENTS.RECEPTION_TRANSFER_SAVED]: {
    label: 'STOCKS.AUDIT_EVENTS.RECEPTION_TRANSFER_SAVED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.RECEPTION_TRANSFER_VALIDATED]: {
    label: 'STOCKS.AUDIT_EVENTS.RECEPTION_TRANSFER_VALIDATED',
    icon: '/images/inpulse/done-black-small.svg',
  },
  [AUDIT_EVENTS.TRANSFER_SET_TO_DRAFT]: {
    label: 'STOCKS.AUDIT_EVENTS.TRANSFER_SET_TO_DRAFT',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.TRANSFER_SET_TO_INVOICED]: {
    label: 'STOCKS.AUDIT_EVENTS.TRANSFER_SET_TO_INVOICED',
    icon: '/images/inpulse/payments-black.svg',
  },
  [AUDIT_EVENTS.TRANSFER_CANCEL_INVOICED]: {
    label: 'STOCKS.AUDIT_EVENTS.TRANSFER_CANCEL_INVOICED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.TRANSFER_CANCEL_SENDING]: {
    label: 'STOCKS.AUDIT_EVENTS.TRANSFER_CANCEL_SENDING',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.TRANSFER_CANCEL_RECEPTION]: {
    label: 'STOCKS.AUDIT_EVENTS.TRANSFER_CANCEL_RECEPTION',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.TRANSFER_UPDATED]: {
    label: 'STOCKS.AUDIT_EVENTS.TRANSFER_UPDATED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },

  // Recipe
  [AUDIT_EVENTS.RECIPE_CREATED]: {
    label: 'ADMIN.RECIPES.AUDIT_EVENTS.CREATED',
    icon: '/images/inpulse/add-black.svg',
  },
  [AUDIT_EVENTS.RECIPE_UPDATED]: {
    label: 'ADMIN.RECIPES.AUDIT_EVENTS.UPDATED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.RECIPE_DISABLED]: {
    label: 'ADMIN.RECIPES.AUDIT_EVENTS.DISABLED',
    icon: '/images/inpulse/power-black-small.svg',
  },
  [AUDIT_EVENTS.RECIPE_ENABLED]: {
    label: 'ADMIN.RECIPES.AUDIT_EVENTS.ENABLED',
    icon: '/images/inpulse/power-black-small.svg',
  },
  [AUDIT_EVENTS.RECIPE_VARIANT_ADDED]: {
    label: 'ADMIN.RECIPES.AUDIT_EVENTS.VARIANT_ADDED',
    icon: '/images/inpulse/add-black.svg',
  },
  [AUDIT_EVENTS.RECIPE_VARIANT_REMOVED]: {
    label: 'ADMIN.RECIPES.AUDIT_EVENTS.VARIANT_REMOVED',
    icon: '/images/inpulse/trash-black-small.svg',
    iconSize: 13,
  },
  [AUDIT_EVENTS.RECIPE_VARIANT_STORES_UPDATED]: {
    label: 'ADMIN.RECIPES.AUDIT_EVENTS.VARIANT_STORES_UPDATED',
    icon: '/images/inpulse/sync-black-small.svg',
  },
  [AUDIT_EVENTS.RECIPE_VARIANT_RENAMED]: {
    label: 'ADMIN.RECIPES.AUDIT_EVENTS.VARIANT_RENAMED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.RECIPE_COMPOSITION_UPDATED]: {
    label: 'ADMIN.RECIPES.AUDIT_EVENTS.COMPOSITION_UPDATED_MAIN',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.RECIPE_VARIANT_COMPOSITION_UPDATED]: {
    label: 'ADMIN.RECIPES.AUDIT_EVENTS.COMPOSITION_UPDATED_VARIANT',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },

  // Product
  [AUDIT_EVENTS.PRODUCT_CREATED]: {
    label: 'ADMIN.PRODUCTS.AUDIT_EVENTS.CREATED',
    icon: '/images/inpulse/add-black.svg',
  },
  [AUDIT_EVENTS.PRODUCT_UPDATED]: {
    label: 'ADMIN.PRODUCTS.AUDIT_EVENTS.UPDATED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.PRODUCT_DISABLED]: {
    label: 'ADMIN.PRODUCTS.AUDIT_EVENTS.DISABLED',
    icon: '/images/inpulse/power-black-small.svg',
  },
  [AUDIT_EVENTS.PRODUCT_ENABLED]: {
    label: 'ADMIN.PRODUCTS.AUDIT_EVENTS.ENABLED',
    icon: '/images/inpulse/power-black-small.svg',
  },
  [AUDIT_EVENTS.PRODUCT_COMPOSITION_UPDATED]: {
    label: 'ADMIN.PRODUCTS.AUDIT_EVENTS.COMPOSITION_UPDATED',
    icon: '/images/inpulse/edit-pen-black-small.svg',
  },
  [AUDIT_EVENTS.PRODUCT_CASHIER_PRODUCTS_UPDATED]: {
    label: 'ADMIN.PRODUCTS.AUDIT_EVENTS.CASHIER_PRODUCTS_UPDATED',
    icon: '/images/inpulse/sync-black-small.svg',
  },
};
